import { Table, Tag } from 'antd';
import React from 'react';
import moment from 'moment';
import { DAYTIME_FORMAT } from '../../constants';

export default function PartnersTable({ withAction, dataSource, selectedRowKeys, onSelectChange, ...props }) {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      fixed: 'left',
      className: 'border-right',
    },
    {
      title: 'Email',
      dataIndex: 'contactEmail',
      key: 'contactEmail',
      width: 220,
      render: (value) => value || '—',
    },
    {
      title: 'Phone',
      dataIndex: 'contactPhone',
      key: 'contactPhone',
      width: 160,
      render: (value) => value || '—',
    },
    {
      title: 'Orders',
      key: 'ordersCount',
      width: 100,
      align: 'center',
      render: (record) => {
        const count = record._count?.orders || 0;
        return count > 0 ? <Tag>{count}</Tag> : '—';
      },
    },
    {
      title: 'Item Types',
      key: 'itemTypesCount',
      width: 110,
      align: 'center',
      render: (record) => {
        const count = record._count?.partnerItemTypes || 0;
        return count > 0 ? <Tag color="blue">{count}</Tag> : '—';
      },
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 180,
      render: (value) => {
        return value ? moment(value).format(DAYTIME_FORMAT) : '';
      },
    },
  ];

  if (withAction) {
    columns.push({
      key: 'action',
      width: 120,
      className: 'border-left',
      fixed: 'right',
      render(record) {
        return withAction(record);
      },
    });
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className="table-job-orders table-common">
      <Table
        columns={columns}
        rowSelection={rowSelection}
        dataSource={dataSource}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
        {...props}
      />
    </div>
  );
}
